__turbopack_context__.v({
  "className": "lexend_f26dc3ab-module__3q9eOG__className",
});
